/** @jsxImportSource preact */
import { h } from 'preact';
import { Modal } from './Modal';

export interface SummarySeriesItem {
  name: string;
  value: number;
  rawCount: number;
  color: string;
}

interface SummaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  seriesData: SummarySeriesItem[];
  totalDocuments: number;
  onViewDocuments: () => void;
}

export function SummaryModal({
  isOpen,
  onClose,
  title,
  seriesData,
  totalDocuments,
  onViewDocuments,
}: SummaryModalProps) {
  const visibleSeries = seriesData.filter((s) => s.rawCount > 0);

  return (
    <Modal isOpen={isOpen} onClose={onClose} width="min(400px, 90vw)">
      <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12, color: 'var(--gc-foreground, inherit)' }}>
        {title}
      </div>

      {visibleSeries.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16 }}>
          {visibleSeries.map((s) => (
            <div
              key={s.name}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontSize: 13,
                color: 'var(--gc-foreground, inherit)',
              }}
            >
              <span
                style={{
                  display: 'inline-block',
                  width: 12,
                  height: 12,
                  borderRadius: 2,
                  background: s.color,
                  flexShrink: 0,
                }}
              />
              <span style={{ flex: 1 }}>{s.name}</span>
              <span style={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums', textAlign: 'right', minWidth: 80 }}>
                {Math.round(s.rawCount)}
                {totalDocuments > 0 && (
                  <span style={{ fontWeight: 400, color: 'var(--gc-text-muted, #6b7280)', marginLeft: 4 }}>
                    ({(s.rawCount / totalDocuments * 100).toFixed(1)}%)
                  </span>
                )}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ padding: 12, textAlign: 'center', color: 'var(--gc-text-muted, #6b7280)', fontSize: 13, marginBottom: 16 }}>
          No data for this bar.
        </div>
      )}

      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type="button"
          onClick={onViewDocuments}
          style={{
            flex: 1,
            padding: '10px 16px',
            fontSize: 13,
            fontWeight: 600,
            border: '1px solid var(--gc-link, #2563eb)',
            background: 'var(--gc-link, #2563eb)',
            color: '#fff',
            borderRadius: 6,
            cursor: 'pointer',
          }}
        >
          View Document List
        </button>
        <button
          type="button"
          onClick={onClose}
          style={{
            padding: '10px 16px',
            fontSize: 13,
            fontWeight: 500,
            border: '1px solid var(--gc-control-border, #d1d5db)',
            background: 'var(--gc-button-bg, #ffffff)',
            color: 'var(--gc-button-text, #111827)',
            borderRadius: 6,
            cursor: 'pointer',
          }}
        >
          Close
        </button>
      </div>
    </Modal>
  );
}
